import { render, staticRenderFns } from "./DonateWerehouse.vue?vue&type=template&id=5509b921&scoped=true&"
import script from "./DonateWerehouse.vue?vue&type=script&lang=js&"
export * from "./DonateWerehouse.vue?vue&type=script&lang=js&"
import style0 from "./DonateWerehouse.vue?vue&type=style&index=0&id=5509b921&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509b921",
  null
  
)

export default component.exports